module.exports = "pegasus/assets/themelp1/app/106.png";